<template>
  <el-dialog
    width="50%"
    title="导入流程"
    :visible="dialog"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      ref="ruleForm"
      label-width="100px"
      :model="ruleForm"
      :rules="rules"
    >
      <el-form-item label="流程名" prop="taskName">
        <el-input
          v-model="ruleForm.taskName"
          placeholder="未填写流程名，则使用文件中流程名"
        ></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input
          type="textarea"
          :rows="3"
          resize="none"
          v-model="ruleForm.description"
          placeholder="未填写流程描述，则使用文件中流程描述"
        ></el-input>
      </el-form-item>

      <el-form-item label="所属组" prop="ownerId">
        <el-select v-model="ruleForm.ownerId" style="width: 100%;">
          <el-option
            v-for="(item, index) in groupOptions"
            :key="index"
            :label="item.groupName"
            :value="item.groupId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="文件" prop="flie">
        <el-upload
          class="upload-task"
          drag
          accept="json"
          ref="upload"
          action="/gavial/v1/task/admin/task/import"
          :limit="1"
          :auto-upload="false"
          :data="ruleForm"
          :with-credentials="true"
          :on-success="onSuccess"
          :on-error="onError"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button :disabled="loading" @click="quit">取 消</el-button>
      <el-button :loading="loading" type="primary" @click="submit">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ImportTask",
  props: { ownerId: { type: String }, dialog: { type: Boolean } },
  data() {
    const validateName = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        if (value.length > 32) {
          callback(new Error("流程名称不能超过32个字符"));
        } else {
          if (/[^A-z0-9_]/g.test(value)) {
            callback(new Error("流程名称仅包含 A-Za-z0-9_"));
          } else {
            callback();
          }
        }
      }
    };
    const validateDesc = (rule, value, callback) => {
      if (value === "" || value.length >= 30) {
        callback();
      } else {
        callback(new Error("流程描述应大于30个字符"));
      }
    };
    return {
      loading: false,
      ruleForm: {
        taskName: "",
        description: "",
        ownerId: "",
      },
      rules: {
        taskName: [
          {
            validator: validateName,
            trigger: "change",
          },
        ],
        description: [
          {
            validator: validateDesc,
            trigger: "change",
          },
        ],
        ownerId: [
          { required: true, message: "请选择所属组", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    groupOptions() {
      return this.$store.state.userGroup;
    },
  },
  methods: {
    quit() {
      this.ruleForm = {
        taskName: "",
        description: "",
        ownerId: "",
      };
      this.$refs.ruleForm.clearValidate();
      this.$refs.upload.clearFiles();
      this.$emit("update:dialog", false);
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid && this.$refs.upload.uploadFiles.length > 0) {
          this.loading = true;
          this.$refs.upload.submit();
        }
      });
    },
    onSuccess(res) {
      console.log(res);
      if (res.code === 200) {
        this.$message.success(`${this.ruleForm.taskName}流程创建成功`);
        this.quit();
      } else {
        this.$message.error(res.msg);
        this.$refs.upload.clearFiles();
      }
      this.loading = false;
    },
    onError() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.upload-task .el-upload {
  width: 100%;
  .el-upload-dragger {
    width: 100%;
  }
}
</style>
